import { Component, Vue } from 'vue-property-decorator';
import { PilotSignUP } from '../../models/jobrolesignup/pilotsignup';
@Component
export default class PilotSignupValidator extends Vue {
  public pilotSignUP: PilotSignUP = new PilotSignUP();
  private pilotSignUperrors = {
    dateOfBirth: '',
    countryOfPassport: '',
    latestFleet: '',
    latestRank: '',
    hoursOnTypeInRank: '',
    totalHours: '',
    countryOfLicense: '',
    typeOfLicense: '',
    licenceAuthority: '',
    latestAirlineCompany: '',
    lastFlightDate: '',
    otherNonFlyingPosition: '',
  };

  validatePilotSignupForm() {
    this.pilotSignUperrors = {
      dateOfBirth: '',
      countryOfPassport: '',
      latestFleet: '',
      latestRank: '',
      hoursOnTypeInRank: '',
      totalHours: '',
      countryOfLicense: '',
      typeOfLicense: '',
      licenceAuthority: '',
      latestAirlineCompany: '',
      lastFlightDate: '',
      otherNonFlyingPosition: '',
    };
    let isValid: boolean = true;
    if (!this.pilotSignUP.dateOfBirth) {
      this.pilotSignUperrors.dateOfBirth =
        'jobrolesignup.pilot.dateofbirth.required';
    }
    if (this.pilotSignUP.passportCountries.length < 1) {
      this.pilotSignUperrors.countryOfPassport =
        'jobrolesignup.pilot.countryOfPassport.required';
    }
    if (!this.pilotSignUP.selectedFleet.value) {
      this.pilotSignUperrors.latestFleet =
        'jobrolesignup.pilot.latestFleet.required';
    }
    if (!this.pilotSignUP.selectedRank.value) {
      this.pilotSignUperrors.latestRank =
        'jobrolesignup.pilot.latestRank.required';
    }
    if (!this.pilotSignUP.hoursOnTypeInRank) {
      this.pilotSignUperrors.hoursOnTypeInRank =
        'jobrolesignup.pilot.hoursOnTypeInRank.required';
    }
    if (!this.pilotSignUP.totalHours) {
      this.pilotSignUperrors.totalHours =
        'jobrolesignup.pilot.totalHours.required';
    }
    if (!this.pilotSignUP.selectedLicence.countryId) {
      this.pilotSignUperrors.countryOfLicense =
        'jobrolesignup.pilot.countryOfLicense.required';
    }
    if (!this.pilotSignUP.selectedLicenceType.value) {
      this.pilotSignUperrors.typeOfLicense =
        'jobrolesignup.pilot.typeOfLicense.required';
    }
    if (!this.pilotSignUP.licenceAuthority.value) {
      this.pilotSignUperrors.licenceAuthority =
        'jobrolesignup.pilot.licenceAuthority.required';
    }
    if (!this.pilotSignUP.latestAirlineCompany) {
      this.pilotSignUperrors.latestAirlineCompany =
        'jobrolesignup.pilot.latestAirlineCompany.required';
    }
    if (!this.pilotSignUP.lastFlightDate) {
      this.pilotSignUperrors.lastFlightDate =
        'jobrolesignup.pilot.lastFlightDate.required';
    }
    if (!Number.isInteger(Number(this.pilotSignUP.totalHours))) {
      this.pilotSignUperrors.totalHours =
        'jobrolesignup.pilot.totalHours.integerOnly';
    }

    if (Number(this.pilotSignUP.totalHours) < 0) {
      this.pilotSignUperrors.totalHours =
        'jobrolesignup.pilot.totalHours.negativeNotAllowed';
    }
    if (!Number.isInteger(Number(this.pilotSignUP.hoursOnTypeInRank))) {
      this.pilotSignUperrors.hoursOnTypeInRank =
        'jobrolesignup.pilot.totalHours.integerOnly';
    }

    if (Number(this.pilotSignUP.hoursOnTypeInRank) < 0) {
      this.pilotSignUperrors.hoursOnTypeInRank =
        'jobrolesignup.pilot.totalHours.negativeNotAllowed';
    }
    Object.keys(this.pilotSignUperrors).forEach((key) => {
      isValid = isValid && !this.pilotSignUperrors[key];
    });
    return isValid;
  }
}
